import { Component, OnInit, ViewChild, Renderer2, Inject, Input } from '@angular/core';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { DOCUMENT } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UnionLocalService } from 'src/app/service/union-local/union-local.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { ExportToCsv } from 'export-to-csv';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-union-locals',
  templateUrl: './union-locals.component.html',
  styleUrls: ['./union-locals.component.scss'],
})
export class UnionLocalsComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  @ViewChild('closebutton2') closebutton2;

  unionLocalsData: any = [];
  unionLocalNames = {};
  searchInfo = {
    status: '',
    search: '',
  };
  mode;
  deleteUnionLocalId;
  statusUnionLocalItem;
  unionLocalStatus;
  activeCount: 0;
  inActiveCount: 0;
  userPermissions;

  @Input() union_locals_setting: any;

  unionLocalForm: FormGroup;

  constructor(
    private jobsService: JobsService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    // Still needed in order for getAndParseUserPermissions to work.
    private localStorageService: LocalstorageService,
    private momentService: MomentService,
    private unionLocalService: UnionLocalService,
    private toastService: ToastService,
  ) {
    this.getUnionLocals();
  }

  ngOnInit(): void {
    this.createForm();

    setTimeout(() => {
      this.loadSelect2();
    }, 100);

    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
  }

  clearDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('.union-local-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  drawDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('.union-local-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChange('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setAttribute() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setAttribute()`;
    this.renderer2.appendChild(this._document.body, s);
  }

  createForm(data = null) {
    if (data != null) {
      this.unionLocalForm = this.formBuilder.group({
        union_local_id: [data.union_local_id, Validators.required],
        description: [data.description, Validators.required],
        status: [data.status, Validators.required],
        employee_type: [data.employee_type, Validators.required],
        title: [data.title, Validators.required],
        wage_rate: [data.wage_rate, Validators.required],
        id: [data.id.toString()],
      });

      this.triggerChange('#editStatus');
    } else {
      this.unionLocalForm = this.formBuilder.group({
        union_local_id: ['', Validators.required],
        description: ['', Validators.required],
        status: ['', Validators.required],
        employee_type: ['JobPointe', Validators.required],
        title: ['Info to Come', Validators.required],
        wage_rate: ['Info to Come', Validators.required],
        id: [''],
      });
    }
  }

  //Set user status data
  setUnionLocalStatusId(event, item) {
    this.statusUnionLocalItem = item;
    this.unionLocalStatus = event.target.checked ? 1 : 0;
  }

  //Change status for union local
  changeStatus(item, status) {
    if (item) {
      let formData = [];
      item.status = status.toString();
      item.id = item.id.toString();
      delete item.created_date;
      delete item.updated_date;
      delete item.is_deleted;
      formData.push(item);
      this.unionLocalService.updateUnionLocals(formData).subscribe(
        res => this.onSubmitSuccess(res),
        error => this.onSubmitError(error),
      );
    }
  }

  //To get all union local data
  getUnionLocals() {
    this.unionLocalService.getUnionLocals(this.searchInfo).subscribe(
      res => this.onUnionLocalsSuccess(res),
      error => this.onUnionLocalsError(error),
    );
  }

  //On success of union locals api call
  onUnionLocalsSuccess(result) {
    if (result?.data) {
      this.clearDatatable();
      this.unionLocalsData = result.data;
      this.unionLocalNames = this.unionLocalsData.reduce((list, union) => {
        list[union.id] = union.description;
        return list;
      }, {});
      this.drawDatatable();
      this.setAttribute();
      this.activeCount = result.data.filter(function (item) {
        return item.status == 1;
      }).length;
      this.inActiveCount = result.data.filter(function (item) {
        return item.status == 0;
      }).length;
    }
  }

  //On error of union locals api call
  onUnionLocalsError(error) { }

  //On submit form
  onSubmit(form) {
    if (form.invalid) {
      this.unionLocalForm.markAllAsTouched();
    } else {
      if (this.mode == 'Add') {
        delete form.value.id;

        const formData = [];
        formData.push(form.value);
        this.unionLocalService.addUnionLocals(formData).subscribe(
          res => this.onSubmitSuccess(res),
          error => this.onSubmitError(error),
        );
      } else if (this.mode == 'Edit') {
        const formData = [];

        formData.push(form.value);
        this.unionLocalService.updateUnionLocals(formData).subscribe(
          res => this.onSubmitSuccess(res),
          error => this.onSubmitError(error),
        );
      }
    }
  }

  //On success of api call
  onSubmitSuccess(result) {
    if (result?.batchResponse) {
      if (result.batchResponse.success.length > 0) {
        this.closebutton.nativeElement.click();
        this.closebutton2.nativeElement.click();
        setTimeout(() => {
          this.getUnionLocals();
        }, 50);
        if (this.mode == 'Edit') {
          this.toastService.showToast('Union Local updated successfully', 'success');
        } else {
          this.toastService.showToast('Union Local added successfully', 'success');
        }
        this.cleanData();
      } else {
        if (result.batchResponse.failure.length > 0) {
          this.toastService.showToast(result.batchResponse.failure[0].errors[0].message, 'error');
        }
      }
    }
  }

  //On error of api call
  onSubmitError(error) { }

  getUnionLocalName(unionLocal) {
    return this.unionLocalNames[unionLocal.id];
  }

  //Set search parameter and get filter data
  searchInTable(value, key) {
    if (value == '') {
      delete this.searchInfo[key];
    }
    this.searchInfo[key] = value;
    this.getUnionLocals();
  }

  //Set action mode
  setMode(mode, id = '') {
    this.mode = mode;
    this.cleanData();
    this.unionLocalForm.get('employee_type').setValue('JobPointe');
    this.unionLocalForm.get('title').setValue('Info to Come');
    this.unionLocalForm.get('wage_rate').setValue('Info to Come');
    if (id != '') {
      this.unionLocalService.getUnionLocalsById(id).subscribe(
        res => this.onUnionLocalGetSuccess(res),
        error => this.onUnionLocalGetError(error),
      );
    }
  }

  //On get success on union local request
  onUnionLocalGetSuccess(result) {
    if (result?.response) {
      this.createForm(result.response);
    }
  }

  //On get error on union local request
  onUnionLocalGetError(error) { }

  //Set union local id to delete on confirm delete modal
  setDeleteUserId(id) {
    this.deleteUnionLocalId = id;
  }

  //Delete union locals based on id
  deleteUnionLocal(id) {
    if (id != '') {
      this.unionLocalService.deleteUnionLocals(id).subscribe(
        res => this.onDeleteSuccess(res),
        error => this.onDeleteError(error),
      );
    }
  }

  //On success of api call
  onDeleteSuccess(result) {
    if (result?.data) {
      this.closebutton1.nativeElement.click();
      this.toastService.showToast(result.data.message, 'success');
      this.getUnionLocals();
    }
  }

  //On error of api call
  onDeleteError(error) { }

  cleanData() {
    setTimeout(() => {
      this.triggerChange('#editStatus');
    }, 200);
    this.unionLocalForm.reset();
  }

  setDataToControl(field, value) {
    if (field == 'union_local_id') {
      this.unionLocalForm.get(field).setValue(value.toUpperCase());
    } else {
      this.unionLocalForm.get(field).setValue(value);
    }
  }

  generateCSV() {
    const options = {
      filename: 'Union Local Data Export CSV',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      // showTitle: true,
      // title: 'Users Data Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    let unionLocalExport = [];
    this.unionLocalsData.forEach(element => {
      let newData = {
        'Union Local': element.union_local_id,
        'Union Local Description': element.description,
        Status: element.status == '1' ? 'Active' : 'Inactive',
        'Employee Type':
          element.employee_type == null || element.employee_type == '' || element.employee_type == undefined
            ? 'JobPointe'
            : element.employee_type,
        Title:
          element.title == null || element.title == '' || element.title == undefined ? 'Info to Come' : element.title,
        'Wage Rate':
          element.wage_rate == null || element.wage_rate == '' || element.wage_rate == undefined
            ? 'Info to Come'
            : element.wage_rate,
      };
      unionLocalExport.push(newData);
    });

    csvExporter.generateCsv(unionLocalExport);
  }
}
